module.exports = "../dist/frontend/icons/ui/yt.svg?2a06c6c811a9fe92add0929dc2dc85b8";